// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4576":"783c1b7a","6070":"18c2f7dc"}[chunkId] + ".chunk.css";
};